import React, { useState, lazy } from 'react';
import { motion } from 'framer-motion';
import { StarIcon } from 'lucide-react';
interface Testimonial {
  name: string;
  location: string;
  stars: number;
  comment: string;
  image: string;
}
const testimonials: Testimonial[] = [{
  name: 'Santi',
  location: 'Buenos Aires',
  stars: 5,
  comment: '¡Una locura el curso! No sabía ni soldar un cable y ayer terminé mi primer cartel de "Open" para un local. Se paga solo.',
  image: 'https://randomuser.me/api/portraits/men/32.jpg'
}, {
  name: 'Matias',
  location: 'Córdoba',
  stars: 5,
  comment: 'Las plantillas son clave. Me ahorraron horas de diseño. Ya tengo 3 pedidos para esta semana. ¡Recomendadísimo!',
  image: 'https://randomuser.me/api/portraits/men/44.jpg'
}, {
  name: 'Gabriela',
  location: 'Rosario',
  stars: 5,
  comment: 'Increíble la calidad del video y la explicación. Todo súper claro, hasta la parte de los proveedores que es oro puro.',
  image: 'https://randomuser.me/api/portraits/women/68.jpg'
}, {
  name: 'Lucas',
  location: 'Mendoza',
  stars: 5,
  comment: 'Buscaba un oficio rentable y lo encontré. El soporte por mail me sacó todas las dudas con la fuente de alimentación.',
  image: 'https://randomuser.me/api/portraits/men/22.jpg'
}, {
  name: 'Valeria',
  location: 'CABA',
  stars: 5,
  comment: 'Hice el curso en un finde y ya armé la decoración de mi cuarto. Ahora mis amigas me piden carteles para sus cumples.',
  image: 'https://randomuser.me/api/portraits/women/33.jpg'
}];
export function TestimonialsSection() {
  const [visibleCount, setVisibleCount] = useState(3);
  const showMore = () => setVisibleCount(prev => Math.min(prev + 3, testimonials.length));
  const visibleTestimonials = testimonials.slice(0, visibleCount);
  const hasMore = visibleCount < testimonials.length;
  return <section className="py-24 px-4 bg-transparent relative z-10 pt-[20px] pb-[20px]" data-id="element-215" data-mp="3sfx0r9p0nhdb">
      <div className="max-w-6xl mx-auto" data-id="element-216" data-mp="3fk3gbp87axu">
        <div className="text-center mb-16" data-id="element-217" data-mp="3eit69g1ash6">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-yellow-400/10 border border-yellow-400/30 text-yellow-400 text-sm font-black mb-6 tracking-widest" data-id="element-218" data-mp="8dc53xfoabf8">
            <StarIcon className="w-4 h-4 fill-yellow-400" data-id="element-219" data-mp="3lt1ilrkaae2c" />
            TESTIMONIOS REALES
          </motion.div>

          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-4xl md:text-6xl font-black text-white mb-6 tracking-tight leading-tight" data-id="element-220" data-mp="3qq08fxwwzyuq">
            LO QUE DICEN{' '}
            <span className="text-[#ec4899]" data-id="element-221" data-mp="1k4tcaqr5wtmp">NUESTROS ALUMNOS</span>
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-xl text-gray-400 max-w-2xl mx-auto font-medium" data-id="element-222" data-mp="1g3g3q8woqcc3">
            Más de 1,500 personas ya están transformando su realidad con el Neon
            Flex.
          </motion.p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-12" data-id="element-223" data-mp="sghvfyipyap9">
          {visibleTestimonials.map((testimonial, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-[#1a0b2e]/40 border border-white/5 rounded-[2rem] p-8 hover:border-[#ec4899]/30 transition-all duration-500 shadow-xl" data-id="element-224" data-mp="ihiqapx5wx70" data-mpi={index}>
              <div className="flex items-start justify-between mb-6" data-id="element-225" data-mp="28sfcpy5c0vpq">
                <div className="flex items-center gap-4" data-id="element-226" data-mp="1utflqjuck4qe">
                  <img src={testimonial.image} alt={testimonial.name} width={56} height={56} className="w-14 h-14 rounded-full object-cover border-2 border-[#00f0ff]/30" loading="lazy" decoding="async" data-id="element-227" data-mp="1ztk7aoa43pnh" />
                  <div data-id="element-228" data-mp="3fau0wj9b46q1">
                    <h3 className="font-black text-white text-lg" data-id="element-229" data-mp="3f8hmgg2rcehq">
                      {testimonial.name}
                    </h3>
                    <p className="text-sm text-[#00f0ff] font-bold" data-id="element-230" data-mp="18lim8zurkois">
                      {testimonial.location}
                    </p>
                  </div>
                </div>
                <div className="flex gap-0.5" data-id="element-231" data-mp="1iblc4r6l9mcw">
                  {[...Array(5)].map((_, i) => <StarIcon key={i} className={`w-4 h-4 ${i < testimonial.stars ? 'fill-yellow-400 text-yellow-400' : 'fill-gray-700 text-gray-700'}`} data-id="element-232" data-mp="1dleqn07dihyv" data-mpi={i} />)}
                </div>
              </div>
              <p className="text-gray-300 text-lg leading-relaxed font-medium italic" data-id="element-233" data-mp="1ndapidhaac45">
                "{testimonial.comment}"
              </p>
            </motion.div>)}
        </div>

        {hasMore && <div className="text-center" data-id="element-234" data-mp="6wg7viqt7fr6">
            <button onClick={showMore} className="inline-flex items-center gap-3 px-10 py-4 bg-transparent border-2 border-[#ec4899] text-[#ec4899] hover:bg-[#ec4899] hover:text-white font-black rounded-2xl transition-all uppercase tracking-widest shadow-[0_0_20px_rgba(236,72,153,0.2)]" data-id="element-235" data-mp="6xhixn7ts28w">
              Ver más testimonios
            </button>
          </div>}
      </div>
    </section>;
}